import { PhImage } from '@phosphor-icons/vue'

import { type BuilderBlockModule } from '@/lib/builder/types'
import i18nPlugin from '@/plugins/i18n'

import {
  type CampaignResource,
  type ImageSection,
  type ImageSectionCreate,
  type ImageSectionUpdate,
} from '../../types'
import { emailBlockMethods } from '../common/methods'

import ImageEditor from './editor/ImageEditor.vue'
import { createImageData } from './methods/createImageData'
import ImagePreview from './preview/ImagePreview.vue'
const i18n = i18nPlugin.global

export const ImageBlockModule: BuilderBlockModule<
  ImageSection,
  ImageSectionCreate,
  ImageSectionUpdate,
  CampaignResource
> = {
  createData: createImageData,
  customEditor: true,
  editor: ImageEditor,
  meta: [
    {
      icon: PhImage,
      key: 'photo',
      label: i18n.t('email-builder.blocks.image'),
    },
  ],
  methods: emailBlockMethods,
  preview: ImagePreview,
}
